import React from 'react';
import MainApplicationForm from './components/mainapplicationform/mainapplicationform'
import './App.scss'; 

function App() {
  return ( 
    <main className='app-container' data-testid="app-container">
      <MainApplicationForm />
    </main>
  );
}

export default App;
